const matchesSearch = (u, s) => !s || [u.full_name, u.phone, u.country].some((v) => (v || "").toLowerCase().includes(s));

const compareBy = (key, dir) => (a, b) => String(a[key] || "").localeCompare(String(b[key] || "")) * dir;

export const filterAndSortUsers = (users, { q, filter, sort, pkgName }) => {
  const s = q.toLowerCase();
  return users
    .filter((u) => filter === "all" || u.status === filter)
    .filter((u) => matchesSearch(u, s))
    .map((u) => ({ ...u, package_name: pkgName(u.package_id) }))
    .sort(compareBy(sort.key, sort.dir));
};

export const countByStatus = (users, status) => users.filter((u) => status === "all" || u.status === status).length;
